import React, { useEffect, useRef } from "react";
import { environment } from "../../environments/environment";

interface EtpayWidgetProps {
  sessionToken: string;
}

const EtpayWidget: React.FC<EtpayWidgetProps> = ({ sessionToken }) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const isFirstLoad = useRef(true);
  const etpayUrl = `${environment.etpayFunnelUrl}/session/${sessionToken}`;

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const handleLoad = () => {
      if (isFirstLoad.current) {
        isFirstLoad.current = false;
        return;
      }

      // Iframe navigated away from ETpay (callback redirect)
      try {
        const url = iframe.contentWindow?.location.href;
        if (url && url !== "about:blank") {
          window.location.replace(url);
        }
      } catch (e) {
        // Cross-origin: can't read the URL
      }
    };

    iframe.addEventListener("load", handleLoad);

    return () => {
      iframe.removeEventListener("load", handleLoad);
    };
  }, []);

  return (
    <iframe
      ref={iframeRef}
      src={etpayUrl}
      title="ETPay"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        border: "none",
        zIndex: 9999,
      }}
    />
  );
};

export default EtpayWidget;
